// The Type cell: Master, Demo or Regular, on one line.

import React from 'react'
import PropTypes from 'prop-types'

export const TypeCell = ({ row }) => (
  <span className="admin-courses-type">{row.type || 'Regular'}</span>
)

TypeCell.propTypes = {
  row: PropTypes.shape({ type: PropTypes.string }).isRequired,
}
